import React from 'react';
import IAqr from 'assets/images/custom_qr_code_aventude.png';
import './_mainArea.scss';
import { Typography } from 'components/atoms';

interface Prop {
  child1?: React.ReactNode;
  child2?: React.ReactNode;
  child3?: React.ReactNode;
  child4?: React.ReactNode;
  child5?: React.ReactNode;
  child6?: React.ReactNode;
  child7?: React.ReactNode;
  child8?: React.ReactNode;
  child9?: React.ReactNode;
  child10?: React.ReactNode;
  child11?: React.ReactNode;
  child12?: React.ReactNode;
  child13?: React.ReactNode;
  child14?: React.ReactNode;
  mode?: string;
}

export const MainArea = ({
  child1,
  child2,
  child3,
  child4,
  child5,
  child6,
  child7,
  child8,
  child9,
  child10,
  child11,
  child12,
  child13,
  child14,
  mode
}: Prop) => {
  return (
    <>
      <div
        className={mode === 'dashboard' ? 'dashboard-main-area' : 'mainArea'}
      >
        {child1}
        {child2}
        {child3}
        {child4}
        {child5}
        {child6}
        {child7}
        {child8}
        {child9}
        {child10}
        {child11}
        {child12}
        {child13}
        {child14}
        <hr className="dashboard-flex-braker" />

        {mode === 'dashboard' ? (
          <div className="integrityalert-wrapper">
            <Typography
              text="Confidential Reporting – IntegrityAlert"
              type="heading4"
              weight="bold"
              className="integrityalert-title"
            />

            <div className="integrityalert-container">
              <img src={IAqr} alt="IntegrityAlert QR code" />

              <div className="inner-wrapper">
                <Typography
                  text="Please scan the QR code or go to:"
                  type="base_medium"
                  className="tile-sub-text"
                />
                <a
                  href="https://tinyurl.com/yc2cdhmw"
                  target="_blank"
                  rel="noreferrer"
                >
                  https://tinyurl.com/yc2cdhmw
                </a>
                <p>
                  We are committed to maintaining a transparent, ethical, and
                  safe workplace. If you witness or experience any misconduct,
                  unethical behavior, or safety concerns, please report it
                  through our confidential whistleblowing and incident reporting
                  platform, IntegrityAlert. Your voice matters, and all reports
                  are handled with strict confidentiality.
                </p>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </>
  );
};
